export const additionalNotesQuestions: Record<string, any> = {
  additionalNotes: {
    labelKey: 'applicationForm.ADDITIONAL_NOTES.label',
    explanationKey: 'applicationForm.ADDITIONAL_NOTES.explanation',
  },
};
